/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import {
  getForteDecisionFlagWithTrueDefault,
  useForteDecisionFlagWithTrueDefault,
} from '@/features/forte/api/getForteDecision';
import { type QueryClient } from '@tanstack/react-query';

type GCPPriceFlags = {
  useGCPPriceService: boolean;
};

/**
 * Retrieves GCP (Google Cloud Platform) price service feature flags fetched from Forte in the query client.
 *
 * @param queryClient - The React Query client instance used to fetch feature flags
 * @returns An object containing GCP price service feature flags
 * @throws Error when queryClient is undefined
 */
export const getGCPPriceFlags = (queryClient: QueryClient | undefined): GCPPriceFlags => {
  if (!queryClient) {
    throw new Error('Forte config is undefined');
  }
  const useGCPPriceService = getForteDecisionFlagWithTrueDefault(queryClient, 'useGCPPriceService');

  return {
    useGCPPriceService,
  };
};

export const useGCPPriceFlags = () => {
  const useGCPPriceService = useForteDecisionFlagWithTrueDefault('useGCPPriceService');

  return {
    useGCPPriceService,
  };
};
